import type * as React from 'react';
import { get } from '@Domain/Api';
import beneficiaryFetched, {
	type BeneficiaryFetchedAction,
	type BeneficiaryPayload,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryFetched';
import beneficiaryFetchFailed, {
	type BeneficiaryFetchFailedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryFetchFailed';
import type FetchBeneficiary from '@Application/Beneficiaries/Beneficiaries/Queries/FetchBeneficiary';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiaryFetchedAction | BeneficiaryFetchFailedAction;

export default (query: FetchBeneficiary) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<BeneficiaryPayload>(
				`${parameters.api.host}/api/facilities/${query.facilityId}/beneficiaries/${query.beneficiaryId}`,
			);

			const action = beneficiaryFetched(payload, query.facilityId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
